import PropTypes from 'prop-types'
import { createCardFromList } from '@usb-ui-tools/react-billpay-layout'
// import USBButton from '@usb-shield/react-button'
import USBIconChevronRight from '@usb-shield/react-icons/dist/esm/icon-chevron-right'
import { useEffect } from 'react'
import USBModal from '../../../../components/modal-wrapper/index'
// import { useRemoveBillStyle } from '../../edit/removeBill/removeBillPopup.style'
import { ellipsis, ProductCode } from '../../../../utils/verifyBills'
import { NativeInterfaceHandler } from '../../../../utils/nativeHandlers'
import { isOLBOrIpadApp, navigateRoute } from '../../../../utils/browserutils'
import { BASE_PATH } from '../../../../config/connections'
import routerpath from '../../../../constants/routerpath'
import { routeController } from '../../../../router/routeController'
import getUSBExBillerLogo from '../../../../utils/extBillerLogo'
import './searchFindPopUp.scss'

/**
 * Returns Remove bill popup
 * @method
 * @param {Object} selBill - selected merchant data
 * @param {String} selPopUp - popup name
 * @param {Boolean} reviewModal - flag value to oprn popup
 * @param {Object} payeeData - payees list
 *
 * @returns {HTMLElement} Returns remove bill popup
 */
const SearchFindPopup = ({
  selBill,
  selPopUp,
  reviewModal,
  // autocompleteRef,
  payeeData,
  setReviewModal,
  lang
}) => {
  // const { removeBillCss } = useRemoveBillStyle()
  const { navigateRoutePath } = navigateRoute()
  useEffect(() => {
    if (reviewModal.openReviewModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [reviewModal.openReviewModal])

  const sortedExternalBillers =
    payeeData &&
    payeeData.filter(
      (el) => el?.billPayPayee?.biller?.merchantAlias === selBill.billerSiteUrl
    )
  // const sortedExternalBillers =
  //   payeeData &&
  //   payeeData.filter(
  //     (el) =>
  //       el?.billPayPayee?.biller?.billerSiteUrl ===
  //       '/api/v1/me/payees/6b84e3a1f8f44118a10c0ede6940edb9'
  //   )
  const sortedInternalBillers =
    payeeData &&
    payeeData.filter((el) => {
      const name = selBill?.billerName?.toLowerCase?.()
      if (el?.billPayPayee?.isPayeeInternal) {
        if (name === 'us bank credit card') {
          return (
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_CCD ||
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_BCD ||
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_EXL
          )
        }
        if (name === 'us bank loans') {
          return (
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_BLN ||
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_SLN ||
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_UNL
          )
        }
        if (name === 'us bank lease') {
          return (
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
            ProductCode.PRODUCTCODE_LEA
          )
        }
        if (name === 'us bank lineofcredit') {
          return (
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_LOC ||
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_SEL
          )
        }
        if (name === 'us bank mortgage') {
          return (
            el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
            ProductCode.PRODUCTCODE_MAL
          )
        }
        if (name === 'us bank') {
          return el && el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode
        }
      }
      return false
    })
  const sortedBillers =
    sortedInternalBillers && sortedInternalBillers.concat(sortedExternalBillers)
  const closePopupHandler = () => {
    NativeInterfaceHandler('PopUpHandler', false)
  }
  const onPayClick = () => {
    closePopupHandler()
    setReviewModal({ openReviewModal: false })
    navigateRoutePath(`${BASE_PATH}${routerpath.pages.search}`)

    if (typeof document !== 'undefined') {
      document.body.style.position = 'relative'
      document.body.style.top = '0px'
      document.body.style.width = ' '
    }
  }
  const formatAccNumber = (accNo) => accNo && accNo.slice(-4)
  const updateGroupedBillersList = (billerId) => {
    const sharedData = {
      currentPath: '/',
      channel: 'OLB',
      AppFlow: 'OPENBILLPAY',
      AppError: false,
      ReturnURL: '',
      successMsg: '',
      payeeId: billerId,
      navTo: isOLBOrIpadApp()
        ? routerpath.pages.home
        : routerpath.pages.billdetails,
      fromPayee: isOLBOrIpadApp() ? '' : 'payee_management',
      siderrailLoad: 'ispayeeMangement'
    }
    NativeInterfaceHandler('PopUpHandler', false)
    routeController(sharedData)

    if (typeof document !== 'undefined') {
      document.body.style.position = 'relative'
      document.body.style.top = '0px'
      document.body.style.width = ''
    }
    // closePopupHandler()
    // setReviewModal({ openReviewModal: false })
  }
  // eslint-disable-next-line no-console
  console.log(sortedBillers, selBill, 'test###')

  const segmentListFunction = ({
    billPayPayee: {
      biller: { billerLogoUrl },
      isPayeeInternal,
      payee: { payeeId, nickName, displayName, payeeAccountInfo }
    }
  }) => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      role="link"
      tabIndex="0"
      data-test="list-item-component"
      onClick={() => updateGroupedBillersList(payeeId)}
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        cursor: 'pointer'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: !isPayeeInternal && 'center'
        }}
      >
        <div>
          <img
            name="logo"
            src={getUSBExBillerLogo(billerLogoUrl)}
            alt="biller logo"
            aria-hidden
            style={{ height: '2.5rem', width: '2.5rem' }}
          />
        </div>
        <div style={{ padding: '0.25rem 0rem 0rem 0.5rem' }}>
          <p>{nickName ? ellipsis(nickName) : ellipsis(displayName || '')}</p>
          {payeeAccountInfo && !isPayeeInternal && (
            <p>
              {payeeAccountInfo &&
                `${lang.SEARCHBILL_ACCOUNTNUMBER}${formatAccNumber(
                  payeeAccountInfo[0].maskedaccountNumber
                )}`}
            </p>
          )}
        </div>
      </div>

      <div>
        {/* <USBButton
          variant="text"
          id="search_bill-btn"
          type="button"
          ariaLabel="search_bill_navigate"
          size="small"
          spacing={{ margin: 0 }}
          handleClick={() => {
            updateGroupedBillersList(payeeId)
          }}
        >
          <USBIconChevronRight colorVariant="interaction" />
        </USBButton> */}
        <div
          style={{ top: '22px' }}
          role="button"
          aria-hidden
          id={`searchBillConfirm-button${payeeId}`}
        >
          <USBIconChevronRight tabIndex="-1" colorVariant="interaction" />
        </div>
      </div>
    </div>
  )
  return (
    <div data-test="searchBillConfirm-compnent" className="padding-columns">
      {selPopUp === 'searchBillConfirm' && (
        <USBModal
          wrapClassName="searchBillConfirmPopup"
          contentClassName="billpay-modal"
          isOpen={reviewModal.openReviewModal}
          modalTitle={`${lang.SEARCHBILL_ANOTHERBILL} ${selBill?.billerName}?`}
          backdrop="static"
          handleModalClose={() => {
            setTimeout(() => {
              // const input = autocompleteRef?.current?.querySelector('input')
              const input = document.querySelector(
                '#add-bill-dashboard-search-input1 > input'
              )
              if (input) {
                input.value = ''
              }
            }, 300)
            closePopupHandler()
            setReviewModal(false)
            document.body.style.position = 'relative'
            document.body.style.top = '0px'
            document.body.style.width = ''
          }}
          wrapID="searchBillConfirm-modal"
          zIndex="1050"
          data-test="modal-component"
          footerButtonOptions={[
            {
              type: 'primary',
              text: lang.SEARCHBILL_ADDNEWBILL,
              id: 'ready-paybtn3',
              clickEvent: () => onPayClick()
            },
            {
              type: 'secondary',
              text: lang.CANCEL,
              id: 'ready-closebtn',
              clickEvent: () => {
                setTimeout(() => {
                  // const input = autocompleteRef?.current?.querySelector('input')
                  const input = document.querySelector(
                    '#add-bill-dashboard-search-input1 > input'
                  )
                  if (input) {
                    input.value = ''
                  }
                }, 300)

                closePopupHandler()
                setReviewModal({ openReviewModal: false })
                document.body.style.position = 'relative'
                document.body.style.top = '0px'
                document.body.style.width = ''
              }
            }
          ]}
        >
          {/* <section className="padding-columns">
          <p style={{ marginLeft: '1rem' }}>{lang.SEARCHBILL_DESCRIPTION}</p>
        </section> */}
          <div id="ready-to-go">
            <div id="paid-segment-list">
              {sortedBillers?.length > 0 &&
                createCardFromList(
                  sortedBillers,
                  segmentListFunction,
                  <div className="usb-tg-superhead usb-c-gray-80">
                    {lang.SEARCHBILL_DESCRIPTION}
                  </div>
                )}
            </div>
          </div>
        </USBModal>
      )}
    </div>
  )
}

SearchFindPopup.propTypes = {
  reviewModal: PropTypes.objectOf(PropTypes.any).isRequired,
  selBill: PropTypes.objectOf(PropTypes.any).isRequired,
  payeeData: PropTypes.arrayOf(PropTypes.any).isRequired,
  selPopUp: PropTypes.objectOf(PropTypes.any).isRequired,
  // autocompleteRef: PropTypes.objectOf(PropTypes.any).isRequired,
  setReviewModal: PropTypes.func.isRequired,
  lang: PropTypes.objectOf(PropTypes.any).isRequired
}

export default SearchFindPopup
